// extracted by mini-css-extract-plugin
export default {"comparison":"Production_comparison__-srMF"};